/**
 * Init rich UI select / listing autocomplete for the edit form listing field.
 */
export function initInlineEditListingAutocomplete(popup) {
  const listingField = popup?.querySelector('.js-showing-view-edit-form .js-showing-view-listing-select.js-sm-rich-ui-select');
  if (!listingField) {
    return;
  }

  document.dispatchEvent(new CustomEvent('sm-rich-ui-select:init', { detail: { el: listingField } }));
}
